var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemperature2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 21.6004C11.0196 21.6004 12.9 19.72 12.9 17.4004C12.9 16.1565 11.9592 14.7223 11.1 13.9532V4.80039C11.1 3.47491 10.0255 2.40039 8.7 2.40039C7.37452 2.40039 6.3 3.47334 6.3 4.79882V13.9532C5.21191 14.7122 4.5 15.9731 4.5 17.4004C4.5 19.72 6.3804 21.6004 8.7 21.6004Z",
    fill: "#6DBFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.22978L16.4119 8.05955C17.0486 7.7964 17.7637 7.79696 18.4 8.06109C19.0363 8.32523 19.7514 8.32578 20.3881 8.06263L20.8 7.8924M16 4.36719L16.4119 4.19696C17.0486 3.93381 17.7637 3.93437 18.4 4.1985C19.0363 4.46264 19.7514 4.46319 20.3881 4.20004L20.8 4.02981",
    stroke: "#6DBFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature2);
export default __webpack_public_path__ + "static/media/temperature2.137843588c510350cb0b53b0cce876d0.svg";
export { ForwardRef as ReactComponent };